import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { login, logout, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in as admin
  React.useEffect(() => {
    if (user?.role === 'admin') {
      navigate('/admin/dashboard');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const success = await login(formData.email, formData.password);
      if (success) {
        // Fetch logged-in user profile to verify role
        const { data } = await api.get('/auth/me');
        if (data.role !== 'admin') {
          toast.error('Access Denied: You do not have Admin privileges');
          logout();
        } else {
          toast.success('Welcome to Admin Portal');
          navigate('/admin/dashboard');
        }
      }
    } catch (error) {
      toast.error('Login failed. Please check credentials.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-md p-8 border border-gray-100">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-purple-100 text-purple-700 mb-3 font-bold text-xl">
            👑
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Admin Portal Login</h1>
          <p className="text-sm text-gray-500 mt-1">Sign in with an Administrator account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Admin Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="admin@example.com"
              className="input-field"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              className="input-field"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full py-3 font-semibold text-base shadow-sm disabled:opacity-50"
          >
            {loading ? 'Authenticating...' : 'Sign In as Admin'}
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-gray-100 text-center space-y-3">
          <p className="text-xs text-gray-500 bg-gray-50 py-2 px-3 rounded border border-gray-100">
            <strong>Default Admin Credentials:</strong><br />
            Email: <code className="text-primary">admin@example.com</code> | Password: <code className="text-primary">password123</code>
          </p>
          <div className="text-xs text-gray-500">
            Looking for regular customer login?{' '}
            <Link to="/login" className="text-primary font-medium hover:underline">
              Customer Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;